import actionCreators from './actionCreators';
import CovidReportAPI from 'media-base-ui/utils/covidReportAPI';

const fetchCovidReports = (args) => async dispatch => {
    dispatch(actionCreators.requestCovidReports(args));
    try {
        const { data } = await CovidReportAPI.fetchCovidReport(args);
        dispatch(actionCreators.covidReportsResponse(true, [], data));
    }
    catch (errors) {
        dispatch(actionCreators.covidReportsResponse(false, errors, []));
    }
};

const fetchCovidReportDateRange = () => async dispatch => {
    dispatch(actionCreators.requestCovidReportDateRange());
    try {
        const covidReportDateRange = await CovidReportAPI.fetchCovidReportDateRange();
        dispatch(actionCreators.covidReportDateRangeResponse(true, [], covidReportDateRange));
    }
    catch (errors) {
        dispatch(actionCreators.covidReportDateRangeResponse(false, errors, []));
    }
};

export default {
    fetchCovidReports,
    fetchCovidReportDateRange,
};
